import { render } from "./BottomListEmojiProp.vue?vue&type=template&id=672dc74d&scoped=true"
import script from "./BottomListEmojiProp.vue?vue&type=script&lang=js"
export * from "./BottomListEmojiProp.vue?vue&type=script&lang=js"

import "./BottomListEmojiProp.vue?vue&type=style&index=0&id=672dc74d&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672dc74d"]])

export default __exports__